export default __webpack_public_path__ + "static/media/pos-billing.511a3034.webp";